import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { SideBarMenu } from '../../SideBarMenu';
import { MainMenu } from '../../mainMenu';

export const SideBarWrapper: FC = () => {
  const menuVersion = useSelector(
    (state: RootState) => state.layoutConfiguration.menuVersion
  );

  return menuVersion === 'old' ? <MainMenu /> : <SideBarMenu />;
};
